import { render, staticRenderFns } from "./app.component.vue?vue&type=template&id=030faa67"
import script from "./app.component.ts?vue&type=script&lang=ts&external"
export * from "./app.component.ts?vue&type=script&lang=ts&external"
import style0 from "./styles/index.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('030faa67')) {
      api.createRecord('030faa67', component.options)
    } else {
      api.reload('030faa67', component.options)
    }
    module.hot.accept("./app.component.vue?vue&type=template&id=030faa67", function () {
      api.rerender('030faa67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app.component.vue"
export default component.exports